import { definePreset } from "@primeuix/themes";
// @ts-ignore-next-line
import Aura from "@primeuix/themes/aura";
export const AnexisPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: "#DBFFF1",
      100: "#B8FFE2",
      200: "#70FFC6",
      300: "#2EFFAB",
      400: "#00E68A",
      500: "#009E60",
      600: "#00804D",
      700: "#00613A",
      800: "#003D25",
      900: "#001F12",
      950: "#000F09",
    },
    surface: {
      50: "#E6E6E6",
      100: "#CCCCCC",
      200: "#999999",
      300: "#666666",
      400: "#333333",
      500: "#000000",
      600: "#000000",
      700: "#000000",
      800: "#000000",
      900: "#000000",
      950: "#000000",
    },
  },
  components: {
    stepper: {
      steppanel: {
        background: "unset",
      },
    },
  },
});
